import React, { useState, useEffect, useContext } from "react";

// Bootstrap components
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

// API
import { getRafflesProducts, getRafflesHero } from "../api/bids";

// Custom Components
import BidProduct from "../components/BidProduct/BidProduct";

// Context
import AlertContext from "../context/AlertContext";

// Custom CSS
import "../assets/scss/pages/raffles.scss";

function Raffles() {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState(null);
  const [pageHeroBackground, setPageHeroBackground] = useState(null);
  const [loadingHeroBackground, setLoadingHeroBackground] = useState(true);

  const alert = useContext(AlertContext);

  useEffect(() => {
    (async () => {
      const response = await getRafflesProducts();
      if (response.error) {
        alert.error("Hubo un error al traer información de productos.");
      } else {
        setProducts(response.docs);
      }
      setLoading(false);
      // if (query.platform) {
      // }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const response = await getRafflesHero();
      // console.log(response);
      if (response.error) {
        alert.error("Hubo un error al traer información de portada.");
      } else {
        setPageHeroBackground(response);
      }
      setLoadingHeroBackground(false);
      // if (query.platform) {
      // }
    })();
  }, []);

  if (loading || loadingHeroBackground) {
    return (
      <div className="raffles__wrapper">
        <Container>
          <p className="py-4">Cargando información...</p>
        </Container>
      </div>
    );
  }
  return (
    <section className="raffles__wrapper">
      <div
        className="jumbotron"
        style={{
          backgroundImage: `url(${pageHeroBackground?.imagen?.url})`,
        }}
      ></div>
      <div className="raffles__header">
        <Container>
          <h3>Rifas</h3>
          <p>
            Te invitamos a que participes en nuestras rifas de relojes originales, las cuales se juegan conforme a los sorteos de lotería nacional mexicana, el ganador será, los últimos tres números si la rifa es de más de 100 números, la ultima cifra si la rifa es de 100 números o el último número si la rifa es de 10 números, del premio mayor ese será el ganador 🏆 todo esto depende al número de participantes que en cada rifa se estipula claramente, nuestras rifas son una forma eficiente en la cual puedes llevarte un súper reloj costoso a un súper precio, el ganador se estipulará en la rifa en cuanto termine el sorteo de la lotería nacional mexicano, comunicándonos con el ganador para hacerle llegar su premio 🏆
          </p>
        </Container>
      </div>
      <div className="raffles__container">
        <Container>
          <Row>
            {products?.map((product, key) => (
              <BidProduct key={key} product={product} />
            ))}
          </Row>
        </Container>
      </div>
    </section>
  );
}

export default Raffles;
